const stripSegments = (pathname: string) =>
  pathname.replace(/\(\w+\)/g, "").replace(/\/+/g, "/");

const isPathnameActive = (rawCurrent: string, rawHref: string) => {
  const current = stripSegments(rawCurrent);
  const href = stripSegments(rawHref);

  if (current === "/") {
    return href === current;
  }

  return href.startsWith(current);
};

export default isPathnameActive;
